import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  margin-top: 8px;
`;

export const Button = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.primary.vividCerulean};
  border-radius: 6px;

  background-color: transparent;
  color: ${({ theme }) => theme.colors.primary.vividCerulean};

  padding: 6px 10px;

  font-size: 12px;

  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;
